<template>
  <v-container grid-list-md text-xs-left fill-height id="main-container" fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card class="mb-3" v-if="balance">
          <v-card-title primary-title>
            <div class="headline" style="width: 100%">
              Ihr Aktuelles Guthaben:
              <span style="float: right; font-weight: bold">
                {{ balance }} €
              </span>
            </div>
          </v-card-title>
        </v-card>

        <v-card
          class="mb-3"
          v-if="openEvents !== null && openEvents.length > 0"
        >
          <v-card-title primary-title>
            <div
              class="headline"
              style="width: 100%"
              v-t="'dashboard.open_events'"
            ></div>
          </v-card-title>

          <v-list v-if="openEvents !== null && openEvents.length">
            <v-list-tile
              v-for="event in openEvents"
              :key="event.id"
              @click="$router.push(`/user/event-registration/${event.id}`)"
            >
              <v-list-tile-action>
                <v-icon>input</v-icon>
              </v-list-tile-action>

              <v-list-tile-content>
                <v-list-tile-title event.name>
                  <strong>
                    {{ $formatDate(event.start) + " - " + event.name }}
                  </strong>
                  {{
                    "(Meldeschluss: " +
                    $formatDate(event.fake_register_end) +
                    ")"
                  }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card>

        <v-card v-if="nextEvents.length > 0" class="mb-3">
          <v-card-title primary-title>
            <div
              class="headline"
              style="width: 100%"
              v-t="'dashboard.following_events'"
            ></div>
          </v-card-title>

          <v-list>
            <v-list-tile
              v-for="event in nextEvents"
              :key="event.id"
              @click="$router.push(`/user/event-registration/${event.id}`)"
            >
              <v-list-tile-action>
                <v-icon>event_available</v-icon>
              </v-list-tile-action>

              <v-list-tile-content>
                <v-list-tile-title>
                  <strong>
                    {{ $formatDate(event.start) + " - " + event.name }}
                  </strong>
                  {{
                    "(Meldeschluss: " +
                    $formatDate(event.fake_register_end) +
                    ")"
                  }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card>

        <v-card v-if="registeredEvents.length" class="mb-3">
          <v-card-title primary-title>
            <div
              class="headline"
              style="width: 100%"
              v-t="'dashboard.booked_events'"
            ></div>
          </v-card-title>

          <v-list>
            <v-list-tile
              v-for="event in registeredEvents"
              :key="event.id"
              @click="
                $router.push(`/user/event-registration-list/${event.event.id}`)
              "
            >
              <v-list-tile-action>
                <v-icon>event_available</v-icon>
              </v-list-tile-action>

              <v-list-tile-content>
                <v-list-tile-title
                  ><strong v-text="event.event.name"></strong>
                  {{ "(" + event.registrations.length + " Meldungen)" }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import EventRegistrationService from "../../services/EventRegistrationService";

export default {
  data() {
    return {
      registeredEvents: [],
      nextEvents: [],
      openEvents: null,
      balance: 0,
    };
  },
  computed: {
    ...mapState(["user", "events", "registrations", "starters"]),
  },
  created() {
    this.loadOpenEvents();
  },
  mounted() {
    this.$set(
      this,
      "registeredEvents",
      EventRegistrationService.eventsWithRegistrations(
        this.registrations.items,
      ),
    );
    this.$set(
      this,
      "nextEvents",
      _.reject(
        _.orderBy(this.events.items, "register_end"),
        (e) => e.is_locked,
      ),
    );
    this.loadBalance();
  },
  methods: {
    loadBalance() {
      this.balance = this.user.balance
        ? (this.user.balance / 100).toFixed(2).replace(".", ",")
        : null;
    },
    loadOpenEvents() {
      if (
        this.openEvents === null &&
        this.starters.loaded &&
        this.events.loaded
      ) {
        let eventIds = _.uniqBy(_.map(this.starters.items, "event_id"));

        let openEvents = _.filter(this.events.items, (e) =>
          _.includes(eventIds, e.id),
        );

        this.$set(this, "openEvents", openEvents);
      }
    },
  },
};
</script>

<style scoped>
#main-container {
  background: url("/meldeportal/static/images/login_background.jpg");
  background-size: cover;
}
</style>
